import React, { useState, useEffect } from 'react';
import { Container, Navbar } from 'react-bootstrap';
import logoImage from '../../../img/logo-aso-atento.png'; // Imagem estática padrão

import './style.css';

type AsoHeaderProps = {
  logo?: string | null; // Define a prop 'logo' como opcional
};

const AsoHeader: React.FC<AsoHeaderProps> = ({ logo }) => {

  const logoSrc = logo || logoImage;

  return (
    <Navbar expand="lg" variant="dark" className="aso-navbar">
      <Container className="aso-container">
        <Navbar.Brand href="#">
          <img src={logoSrc} className='logo-aso-atento' alt="Logo" />
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
};

export default AsoHeader;
